import type { PropsWithChildren } from "react";
import { classNames } from "@/react/helpers/twMergeWithCN";

interface FormGroupProps {
  className?: string;
  isEnabled: boolean;
}

export const FormGroup = ({
  isEnabled,
  children,
  className,
}: PropsWithChildren<FormGroupProps>) => (
  <div
    className={classNames("divide-primary space-y-5 divide-y", className, {
      "pointer-events-none opacity-50": !isEnabled,
    })}
  >
    {children}
  </div>
);
